function useCopyToClipboard() {
  async function handleCopyButtonClick(textToCopy: string): Promise<boolean> {
    try {
      await navigator.permissions.query({ name: 'clipboard-write' as PermissionName })
      await navigator.clipboard.writeText(textToCopy)
      return true
    } catch (e) {
      console.error('Failed to copy text to clipboard:', e)
      return false
    }
  }

  return handleCopyButtonClick
}

export default useCopyToClipboard